import { Button, Col, Form, Modal, Radio, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import Panel from '../../../../../../shared/components/card/Panel';
import { benefSearch, setAdmissionForm, setBeneficiaryList, setbillAmountArray, setClassificationArray, setIsAbhaVerified,
  setIsShowAdmissionForm,
   setSelectedBeneficiary, setSelectedTab, setUploadedFiles, toggleOtherProcedure, updatePackageSelection } from '../../../../../../store/actions/newAdmissionAction';
import { useDispatch, useSelector } from 'react-redux';
import { FormInputMobile, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import { RootState } from '../../../../../../store';

import { clearNHCXState, getIPODetails, getPolicySearchResults, setCoverageId, setCardChanged, setIPOId, setMemberName,
  setPayerDropDownVisible, setPolicySearchResults, setSelectedPolicyDetail,
  setRadioValue} from '../../../../../../store/actions/nhcxAction';
import { NHCXState } from '../../../../../../store/models/nhcxModel';
import { centeredNotification, getMobileFormat } from '../../../../../../utils/utility';
import { Payer } from '../../../../../../shared/models/payer.model';
import { FILTER_KEY_FOR_COVERAGE, FILTER_KEY_FOR_IPO, GUTTOR_SPACE, PASSWORD_NOT_VERIFIED_ERROR, VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { changePayer } from '../../../../../../store/actions/payerListAction';
import { MailboxType } from '../../../../../../store/models/mailBoxModel';
import { cloneDeep, isEmpty } from 'lodash';
import { DEFAULT_ADMISSION_FORM_VALUE, SELECT_RIGHT_POLICY } from '../../../../../../shared/constants/crmConstants';
import { setClaimData } from '../../../../../../store/actions/claimDetailsAction';
import useSetDefaultPayer from '../../../../../../shared/hooks/useSetDefaultPayer';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import { useSmoothScroll } from '../../../../../../shared/hooks/useSmoothScroll';
import PolicySearchCard from '../cards/BeneficiaryCard/PolicySearchCard';

const PolicySearch = (props: any): ReactElement | null => {
  useSmoothScroll('policySearchDiv');
  const {baseForm} = props;
  const dispatch = useDispatch();
  const [showPanel, setShowPanel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cardLoading, setCardLoading] = useState(false);
  const [tempPolicyDetail, setTempPolicyDetail] = useState<any>(null);
  const [confirmedPolicyDetail, setConfirmedPolicyDetail] = useState<any>(null);
  const [policySearchForm] = Form.useForm();
  const [disableSearch, setDisableSearch] = useState<boolean>(true);
  const [optionValue, setOptionValue] = useState('');
  const { policySearchList, cardChanged, selectedPolicyDetail } = useSelector((state: RootState): NHCXState => state.nhcx);
  const configuredPayers = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const { isDraftSelected } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payerConfiguration: payerConfig = {} as any } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { payers } = payerConfig || {};
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const { selectedPatientDetail} = useSelector((state: RootState): any => state.hospital);
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const setDefaultPayer = useSetDefaultPayer();

  useEffect((): any => {
    onChange('insurance');
  }, []);

  useEffect((): any => {
    if (payer?.id !== 0) {
      dispatch(setIsShowAdmissionForm(true));
    } else {
      dispatch(setIsShowAdmissionForm(false));
    }
  }, [payer]);

  const onChange = (event: any): any => {
    policySearchForm.resetFields();
    setOptionValue(event?.target?.value);
    dispatch(clearNHCXState());
    initiateMemberForm();
    baseForm?.resetFields(['payer']);
    setDefaultPayer();
    if (event?.target?.value === 'insurance') {
      dispatch(setPayerDropDownVisible(true));
      setShowPanel(false);
    } else {
      if (event?.target?.value === 'abha' || event?.target?.value === 'mobile') {
        setShowPanel(true);
        dispatch(setPayerDropDownVisible(false));
      }
    }
    event?.target?.value && dispatch(setRadioValue(event?.target?.value));
  };

useEffect( (): void => {
  if (!isEmpty(selectedPatientDetail)) {
    policySearchForm.setFieldsValue({
      patientName: selectedPatientDetail.memberName || selectedPatientDetail?.patientDetails?.patientName});
    if (optionValue === 'abha') {
      policySearchForm.setFieldsValue({healthId: selectedPatientDetail?.patientDetails?.abhaId});
      }
    if (optionValue === 'mobile') {
      policySearchForm.setFieldsValue({
        mobileNo: getMobileFormat(
          selectedPatientDetail?.mobile || selectedPatientDetail?.patientDetails?.mobileNumber)});
    }
  }
  validateFields();
}, [selectedPatientDetail, optionValue]);

  const onSearch = (): any => {
    const formattedMobileNo = policySearchForm.getFieldValue(['mobileNo'])?.replace('+91', '')?.replace(/ /g, '');
    const payload = {
      'patientName': policySearchForm.getFieldValue(['patientName']),
      'mobileNo': formattedMobileNo,
      'healthId': policySearchForm.getFieldValue(['healthId']),
      'isNHCXEnabledProvider': true,
      'isDirectFlow': false,
    };
    const patientName = policySearchForm.getFieldValue(['patientName']);
    dispatch(setMemberName(patientName));
    policySearchForm.validateFields().then((): any => {
      dispatch(getPolicySearchResults(payload, onSuccess, onError));
      setLoading(true);

    }).catch((): any => {
      centeredNotification('Please enter the fields to Proceed');
    });
  };

  const onSuccess = (policyDetails: any): any => {
    setLoading(false);
    policyDetails?.map((ele: any): any => {
      const policyPayerName = configuredPayers.filter((payerValue: any): any => payerValue?.key === String(ele?.payerId));
      if (policyPayerName?.[0]?.name !== undefined) {
        ele.payerName = policyPayerName?.[0]?.name;
        ele.disabled = false;
        ele.nhcxEnabledRoutingApi = policyPayerName?.[0]?.nhcxEnabledRoutingApi;
        ele.nhcxEnabledPayerForProvider = policyPayerName?.[0]?.isNHCXEnabledPayerProvider;
      } else {
        ele.disabled = true;
      }
    });
    dispatch(setPolicySearchResults(policyDetails));

  };

  const onError = (): void => {
    setLoading(false);
    const option = `${optionValue}`.toUpperCase();
    centeredNotification(`There is no Policy found for the given ${option} Number`);
  };

  const prefillPayer = (selected?: any): any => {
    if (selected) {
      const payerDetail: Payer | undefined = configuredPayers.find(
        ({ uniqueIdentifier }: Payer): boolean => uniqueIdentifier === String(selected),
      );
      if (payerDetail && !isDraftSelected) {
        dispatch(changePayer(payerDetail));
        dispatch(setIsShowAdmissionForm(false));
        dispatch(setCardChanged(!cardChanged));
        const selectedPayer = payers?.find((item: any): any =>
          payerDetail?.id === item['payerID'],
        );
        if (payerDetail.isRpaPayer && (selectedPayer && selectedPayer?.isEnabled === false)) {
          centeredNotification(PASSWORD_NOT_VERIFIED_ERROR);
        }
      }
    }
  };
  const validateFields = (): any => {
    setTimeout((): any => {
      policySearchForm
        ?.validateFields()
        .then((): any => {
          setDisableSearch(false);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisableSearch(true);
          }
        });
    }, 200);
  };
  const onIPOSucess = (data: any): void => {
    dispatch(setIPOId(data));
    setCardLoading(false);
  };
  const onIPOError = (): void => {
    setCardLoading(false);
  };

  const onCoverageSuccess = (data: any): any => {
    const memberCorelationId = data?.[0]?.memberCorelationId;
    dispatch(setCoverageId(memberCorelationId));
    setCardLoading(false);
  };
  const onCoverageError = (): void => {
    setCardLoading(false);
  };
  const onClick = (selected: any): any => {
    if (policySearchList?.length > 0 && selected !== selectedPolicyDetail) {
    setIsConfirmModalVisible(true);
    } else {
      setIsConfirmModalVisible(false);
    }
    setTempPolicyDetail(selected);
  };
  const confirmCardSelection = (): any => {
    const formattedProductCode = tempPolicyDetail?.productId?.split('|')[0];
    tempPolicyDetail.productCode = formattedProductCode;
    setConfirmedPolicyDetail(tempPolicyDetail);
    setCardLoading(true);
    dispatch(setSelectedPolicyDetail(tempPolicyDetail));
    setIsConfirmModalVisible(false);
    prefillPayer(tempPolicyDetail?.payerId);
    const payload = {
      'isNHCXEnabledProvider': true,
      'isDirectFlow': false,
      'productId': tempPolicyDetail?.productId,
      'payerId': tempPolicyDetail?.payerId,
      'memberId': tempPolicyDetail?.memberId,
      'patientName': policySearchForm.getFieldValue(['patientName']),
      'policyNumber': tempPolicyDetail?.policyNumber ||  undefined,
      'productName' : tempPolicyDetail?.productName || undefined,
      'healthId' : tempPolicyDetail?.abhaNo || undefined,
    };

    const filterForRoutingAPI = tempPolicyDetail?.nhcxEnabledRoutingApi;
    if (filterForRoutingAPI?.length && tempPolicyDetail?.nhcxEnabledPayerForProvider) {
      if (filterForRoutingAPI?.includes(FILTER_KEY_FOR_IPO)) {
        dispatch(getIPODetails(payload, onIPOSucess, onIPOError));
      }
      if (filterForRoutingAPI?.includes(FILTER_KEY_FOR_COVERAGE)) {
        dispatch(benefSearch(payload, onCoverageSuccess, onCoverageError));
      }
    } else {
      setCardLoading(false);
    }
    dispatch(setPayerDropDownVisible(true));
    initiateMemberForm();
  };

  const closeModal = (): any => {
    setIsConfirmModalVisible(false);
    setCardLoading(false);
  };

  const initiateMemberForm = (): void => {
    dispatch(setBeneficiaryList([]));
    dispatch(setIsShowAdmissionForm(false));
    dispatch(setSelectedBeneficiary(null));
    dispatch(setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(setUploadedFiles([]));
    dispatch(setIsAbhaVerified(false, {}));
    dispatch(setIsShowAdmissionForm(false));
    dispatch(toggleOtherProcedure(false));
    dispatch(setClassificationArray([]));
    dispatch(setbillAmountArray([]));
    dispatch(setSelectedTab(-1));
    dispatch(setClaimData({}));
    dispatch(updatePackageSelection([]));
  };

  return (
    <>
      <Panel>
        <div className="policySearchDiv"> Search policy using: </div>
        <Radio.Group onChange={onChange} defaultValue={'insurance'}>
          <Radio value="insurance" name="insurance" data-testid="insurance">Insurer</Radio>
          <Radio value="abha" name="abha" data-testid="abha">ABHA ID</Radio>
          <Radio value="mobile" name="mobile" data-testid="mobile">Mobile No</Radio>
        </Radio.Group>
      </Panel>
      {showPanel &&
        <>
          <Panel>
            <Form
              form={policySearchForm}
              layout="vertical"
              noValidate={true}
              onValuesChange={validateFields}
              validateMessages={VALIDATE_MESSAGES}
            >

              <Row gutter={24}>
                <Col md={12}>
                  <FormTextInput detail={{
                    key: 'patientName',
                    label: 'Name',
                    required: true,
                    placeholder: 'Enter Your Full Name',
                  }}
                  />
                </Col>
                {optionValue === 'mobile' &&
                  <Col md={12}>
                    <FormInputMobile detail={{
                      key: 'mobileNo',
                      label: 'Mobile No.',
                      required: true,
                      placeholder: 'Enter Your Mobile Number',
                    }}
                    />
                  </Col>
                }
                {optionValue === 'abha' &&
                  <Col md={12}>
                    <FormTextInput detail={{
                      key: 'healthId',
                      label: 'ABHA Number',
                      required: true,
                      placeholder: 'Enter Your ABHA Number',
                    }}
                    />
                  </Col>
                }
                <Col md={24} className="text-right mt-sm">
                  <Button
                    type= {disableSearch ? undefined : 'primary'}
                    loading={loading}
                    onClick={onSearch}
                    className={`his-next-button
                    ${disableSearch ? 'benef-submit-disabled' : 'benef-submit-btn'}
                  `}
                  disabled={disableSearch}
                    >Search</Button>
                </Col>
              </Row>
            </Form>
            <></>
            <Row className="policyOptionsDiv">
              <Modal
                visible={isConfirmModalVisible}
                onCancel={(): any => closeModal()}
                width={500}
                bodyStyle = {{ marginTop: '50px'}}
                footer={[
                  <Button key="close" type="default" onClick={(): any => {
                      closeModal();
                  }}>
                    Cancel
                  </Button>,
                  <Button key="submit" type="primary" onClick={(): any => {
                    confirmCardSelection();
                  }}>
                    Proceed
                  </Button>,
                ]}
              >
                <div className="mt-md">{SELECT_RIGHT_POLICY}</div>
              </Modal>
            </Row>
          </Panel>
        </>
      }    <Row gutter={GUTTOR_SPACE}>
            {policySearchList?.map((policyDetail: any, index: any): ReactElement => {
                return <>
                  <Col md={12} key={index}
                    onClick={(): void => !(policyDetail?.disabled) && (policyDetail !== selectedPolicyDetail)
                    ? onClick(policyDetail) : undefined}>
                    <PolicySearchCard
                      isSelected={policyDetail === tempPolicyDetail}
                      loading={cardLoading}
                      policySearchResults={policyDetail}
                      index={index}
                      disabled={(policyDetail?.disabled)}
                      isConfirmed = {policyDetail === confirmedPolicyDetail}
                    />
                  </Col>
                </>;
              })}
              </Row>

    </>
  );
};
export default PolicySearch;
